import { IListItem} from '../../list-page/interfaces/interfaces';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';

interface IProductSubscriptionTiersTextABTEST {
    product: IListItem,
    className?: string,
    returnFunc?: Function,
}

const ProductSubscriptionTiersTextABTEST = (props: IProductSubscriptionTiersTextABTEST) => {

    const { product, className } = props;

    // const url = `/subscriptions?skus=${ product.skuid }`;

    const sendGoogleEvents = () => {
        sendGAEvent('Subscribe', product.documentName);

        if (props?.returnFunc) {
            props?.returnFunc();
        }
    };

    const alsoIncludedText = product.skuNumber === 'WGEMS' ? 'Included' : 'Also included';

    return (
        <div className={ `text-sm mt-4 ${ className || '' }` } data-grid-sbs-text="true">

                <>
                    {
                        product.sbsIncludedIn === 1 &&
                        <span>{ alsoIncludedText } in Waves Ultimate: <button type="button" className="underline text-blue-200" onClick={ sendGoogleEvents }>Subscribe</button></span>
                    }

                    {
                        product.sbsIncludedIn === 2 &&
                        <span>{ alsoIncludedText } in Waves Essential & Ultimate: <button type="button" className="underline text-blue-200" onClick={ sendGoogleEvents }>Subscribe</button></span>
                    }

                    {
                        !product.sbsIncludedIn && <span>&nbsp;</span>
                    }
                </>
        </div>
    )
};

export default ProductSubscriptionTiersTextABTEST;